import Vue from 'vue'
import ja from "vee-validate/dist/locale/ja.json";
import en from "vee-validate/dist/locale/en.json";
import {ValidationProvider, ValidationObserver, extend, configure, localize } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import i18n from '@/i18n';

localize({
  en,
  ja
});

configure({
  classes: {
    valid: 'is-success',
    invalid: 'is-danger',
    //dirty: ['is-dirty', 'is-dirty'], // multiple classes per flag!
    // ...
  }
});

const importRules = ['is_not','regex','oneOf','required','required_if','email','min','max','min_value']

// with typescript
for (const [rule, validation] of Object.entries(rules)) {
  if(! importRules.includes(rule)){
    continue;
  }

  extend(rule, {
    ...validation
  });
}

const minPeriodRule = {
  validate: (value: string, args: any) => {
    const period = args[0] || 0
    return period > 0
  },
  message: i18n.t('event.periodInvalid') as string
}

extend('minperiod', minPeriodRule)

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)